import React from 'react';
import { Form, notification, Spin } from 'components/ds';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { ButtonLarge, FooterDiv } from '../../../../components/Css';
import { useNavigate } from 'react-router-dom';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { useGetUserByUsername } from '../../services/AccountService';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import UserNameField from '../../components/UserNameField/UserNameField';

const Otp: React.FC = () => {
  const [form] = Form.useForm() as any;
  const { data: pageConfig = {} } = useGetTemplate('otp');
  const navigate = useNavigate();
  const { mutateAsync: getUserByUsername, isLoading: isUsernameChecking } = useGetUserByUsername();

  const handleNext = async (values: any) => {
    try {
      let userData;
      
      try {
        userData = await getUserByUsername(values.username);
        
        if (!userData) {
          notification.error({
            message: 'Usuário não encontrado',
            description: 'Este usuário não está registrado. Verifique se o nome de usuário está correto.'
          });

          return;
        }

        ApiLocalStorage.set('username', values.username);
        navigate(pageConfig.navigateTo());
      } catch (error) {
        // erro já tratado pelo useGetUserByUsername
      }
    } catch (error) {
      // ... existing error handling ...
    }
  };

  const submitForm = () => {
    form.submit();
  };

  return (
    <PageContainer title={pageConfig.title} navigateBack={pageConfig?.navigateBack?.()}>

      <Form form={form} layout='vertical' onFinish={handleNext}>
      <UserNameField />
      </Form>
      <FooterDiv>
        <ButtonLarge onClick={submitForm} loading={isUsernameChecking}>
          {isUsernameChecking ? (
            <>
              <Spin /> Validando...
            </>
          ) : (
            pageConfig.labelNext
          )}
        </ButtonLarge>
      </FooterDiv>
    </PageContainer>
  );
};

export default Otp;
